(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f2c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f2c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9vxaA", function(module, exports) {
document.addEventListener("DOMContentLoaded", function() {
    var backToTopLink = document.querySelector(".scroll-to-top");
    window.direct.showToTop = function() {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 300) backToTopLink.classList.add("show");
        else backToTopLink.classList.remove("show");
    };
    backToTopLink.addEventListener("click", function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
    window.onscroll = function() {
        if (document.querySelector(".in-page-sub-nav")) {
            var scrollPosInPageNav = window.direct.getPosition(document.querySelector(".in-page-sub-nav"));
            if (scrollPosInPageNav.y === 0) document.querySelector(".in-page-sub-nav").classList.add("remove-radius");
            else document.querySelector(".in-page-sub-nav").classList.remove("remove-radius");
        }
        window.direct.showToTop();
    };
});

});

parcelRegister("kSuI9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f330ac5f61e1368d$export$7c398597f8905a1; });
function $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $f330ac5f61e1368d$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("l29cN", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $f500ece5c74d6d3d$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $l0HdX = parcelRequire("l0HdX");
var $f500ece5c74d6d3d$var$extendStatics = function extendStatics1(d, b) {
    $f500ece5c74d6d3d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f500ece5c74d6d3d$var$extendStatics(d, b);
};
function $f500ece5c74d6d3d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f500ece5c74d6d3d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f500ece5c74d6d3d$export$18ce0697a983be9b = function __assign1() {
    $f500ece5c74d6d3d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f500ece5c74d6d3d$export$18ce0697a983be9b.apply(this, arguments);
};
function $f500ece5c74d6d3d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f500ece5c74d6d3d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f500ece5c74d6d3d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f500ece5c74d6d3d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f500ece5c74d6d3d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f500ece5c74d6d3d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l0HdX._)(x)) === "symbol" ? x : "".concat(x);
}
function $f500ece5c74d6d3d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $l0HdX._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f500ece5c74d6d3d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f500ece5c74d6d3d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f500ece5c74d6d3d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f500ece5c74d6d3d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f500ece5c74d6d3d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f500ece5c74d6d3d$export$45d3717a4c69092e(o, m, p);
}
function $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f500ece5c74d6d3d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f500ece5c74d6d3d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f500ece5c74d6d3d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f500ece5c74d6d3d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f500ece5c74d6d3d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f500ece5c74d6d3d$export$10c90e4f7922046c(v) {
    return this instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? (this.v = v, this) : new $f500ece5c74d6d3d$export$10c90e4f7922046c(v);
}
function $f500ece5c74d6d3d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f500ece5c74d6d3d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f500ece5c74d6d3d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f500ece5c74d6d3d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f500ece5c74d6d3d$export$19a8beecd37a4c45 === "function" ? $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f500ece5c74d6d3d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f500ece5c74d6d3d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f500ece5c74d6d3d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f500ece5c74d6d3d$export$45d3717a4c69092e(result, mod, k);
    }
    $f500ece5c74d6d3d$var$__setModuleDefault(result, mod);
    return result;
}
function $f500ece5c74d6d3d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f500ece5c74d6d3d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f500ece5c74d6d3d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f500ece5c74d6d3d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f500ece5c74d6d3d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f500ece5c74d6d3d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f500ece5c74d6d3d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f500ece5c74d6d3d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f500ece5c74d6d3d$export$2e2bcd8739ae039 = {
    __extends: $f500ece5c74d6d3d$export$a8ba968b8961cb8a,
    __assign: $f500ece5c74d6d3d$export$18ce0697a983be9b,
    __rest: $f500ece5c74d6d3d$export$3c9a16f847548506,
    __decorate: $f500ece5c74d6d3d$export$29e00dfd3077644b,
    __param: $f500ece5c74d6d3d$export$d5ad3fd78186038f,
    __metadata: $f500ece5c74d6d3d$export$f1db080c865becb9,
    __awaiter: $f500ece5c74d6d3d$export$1050f835b63b671e,
    __generator: $f500ece5c74d6d3d$export$67ebef60e6f28a6,
    __createBinding: $f500ece5c74d6d3d$export$45d3717a4c69092e,
    __exportStar: $f500ece5c74d6d3d$export$f33643c0debef087,
    __values: $f500ece5c74d6d3d$export$19a8beecd37a4c45,
    __read: $f500ece5c74d6d3d$export$8d051b38c9118094,
    __spread: $f500ece5c74d6d3d$export$afc72e2116322959,
    __spreadArrays: $f500ece5c74d6d3d$export$6388937ca91ccae8,
    __spreadArray: $f500ece5c74d6d3d$export$1216008129fb82ed,
    __await: $f500ece5c74d6d3d$export$10c90e4f7922046c,
    __asyncGenerator: $f500ece5c74d6d3d$export$e427f37a30a4de9b,
    __asyncDelegator: $f500ece5c74d6d3d$export$bbd80228419bb833,
    __asyncValues: $f500ece5c74d6d3d$export$e3b29a3d6162315f,
    __makeTemplateObject: $f500ece5c74d6d3d$export$4fb47efe1390b86f,
    __importStar: $f500ece5c74d6d3d$export$c21735bcef00d192,
    __importDefault: $f500ece5c74d6d3d$export$da59b14a69baef04,
    __classPrivateFieldGet: $f500ece5c74d6d3d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f500ece5c74d6d3d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f500ece5c74d6d3d$export$81fdc39f203e4e04,
    __addDisposableResource: $f500ece5c74d6d3d$export$88ac25d8e944e405,
    __disposeResources: $f500ece5c74d6d3d$export$8f076105dc360e92
};

});
parcelRegister("l0HdX", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $f4bb2077aa61b74c$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $f4bb2077aa61b74c$export$5f0017c582d45a2d; });
function $f4bb2077aa61b74c$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("c6Xmf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8d1416c8f734345e$export$1b5e630bc3aea29f; });

var $2BACi = parcelRequire("2BACi");

var $djrl5 = parcelRequire("djrl5");

var $jix3C = parcelRequire("jix3C");

var $1hjNY = parcelRequire("1hjNY");
function $8d1416c8f734345e$export$1b5e630bc3aea29f(arr) {
    return (0, $2BACi._array_without_holes)(arr) || (0, $djrl5._iterable_to_array)(arr) || (0, $1hjNY._unsupported_iterable_to_array)(arr) || (0, $jix3C._non_iterable_spread)();
}

});
parcelRegister("2BACi", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $1e5b70c2c2307a84$export$7e0947b5ad3404e2; });

var $QCMVH = parcelRequire("QCMVH");
function $1e5b70c2c2307a84$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $QCMVH._array_like_to_array)(arr);
}

});
parcelRegister("QCMVH", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $09e2f1f84ceddf09$export$79e617b1955a2616; });
function $09e2f1f84ceddf09$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("djrl5", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $9b1241b318447a2a$export$1eb58a6e75231000; });
function $9b1241b318447a2a$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("jix3C", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $e0c9573dc9b3384a$export$e6f3c4780d19eb2b; });
function $e0c9573dc9b3384a$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("1hjNY", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $0ee6bdd820e270f4$export$a5be06335b3a083c; });

var $QCMVH = parcelRequire("QCMVH");
function $0ee6bdd820e270f4$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $QCMVH._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $QCMVH._array_like_to_array)(o, minLen);
}

});


document.addEventListener("DOMContentLoaded", function() {
    var darkModeToggle = document.querySelector("#toggleMode");
    var prefersDarkMode = window.matchMedia("(prefers-color-scheme:dark)").matches;
    var currentTheme = localStorage.getItem("theme");
    if (currentTheme === "dark" || currentTheme === null && prefersDarkMode) {
        document.querySelector("#toggleMode").checked = true;
        setDark();
    } else {
        document.querySelector("#toggleMode").checked = false;
        setLight();
    }
    darkModeToggle.addEventListener("change", function() {
        var currentTheme = localStorage.getItem("theme");
        currentTheme === "light" ? setDark() : setLight();
    });
    function setDark() {
        document.documentElement.classList.add("dark-theme");
        document.documentElement.classList.remove("light-theme");
        document.querySelector("#toggleMode").checked = true;
        document.documentElement.style.display = "block";
        localStorage.setItem("theme", "dark");
    }
    function setLight() {
        document.documentElement.classList.add("light-theme");
        document.documentElement.classList.remove("dark-theme");
        document.querySelector("#toggleMode").checked = false;
        document.documentElement.style.display = "block";
        localStorage.setItem("theme", "light");
    }
});


document.addEventListener("DOMContentLoaded", function() {
    window.direct.getPosition = function(el, rel) {
        var x = 0, y = 0;
        do {
            x += el.offsetLeft;
            y += el.offsetTop;
            el = el.offsetParent;
        }while (el != rel);
        return {
            x: x,
            y: y
        };
    };
    window.direct.selectText = function(element) {
        var doc = document, text = element, range, selection;
        if (doc.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };
    // Wrap an HTMLElement around another HTMLElement or an array of them.
    HTMLElement.prototype.wrapAll = function(elms) {
        var el = elms.length ? elms[0] : elms;
        // Cache the current parent and sibling of the first element.
        var parent = el.parentNode;
        var sibling = el.nextSibling;
        // Wrap the first element (is automatically removed from its
        // current parent).
        this.appendChild(el);
        // Wrap all other elements (if applicable). Each element is
        // automatically removed from its current parent and from the elms
        // array.
        while(elms.length)this.appendChild(elms[0]);
        // If the first element had a sibling, insert the wrapper before the
        // sibling to maintain the HTML structure; otherwise, just append it
        // to the parent.
        if (sibling) parent.insertBefore(this, sibling);
        else parent.appendChild(this);
    };
});


parcelRequire("9vxaA");
document.addEventListener("DOMContentLoaded", function() {
    window.scrollToElement = function(id) {
        var element = document.getElementById("".concat(id));
        if (element) {
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.scrollY - 100;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
});


document.addEventListener("DOMContentLoaded", function() {
    new window.Vue({
        name: "searchBar",
        el: "#search-component",
        data: function data() {
            return {
                query: "",
                showSearch: false,
                searchResults: [],
                pages: [],
                noResults: false
            };
        },
        methods: {
            closeSearch: function closeSearch() {
                this.showSearch = false;
                document.querySelector("body").classList.remove("in-search");
                this.pages = [];
                this.searchResults = [];
                this.noResults = false;
                window.history.pushState({}, document.title, window.location.pathname);
            },
            openSearchBar: function openSearchBar() {
                this.showSearch = true;
                document.querySelector("body").classList.toggle("in-search");
            },
            afterEnter: function afterEnter() {
                this.$refs.query.focus();
            },
            doSearch: function doSearch() {
                window.location = "/search?q=".concat(this.query);
            }
        }
    });
});


document.addEventListener("DOMContentLoaded", function() {
    // open dropdown if li active
    if (document.querySelector(".nav-aside")) {
        var activeLiElements = document.querySelectorAll(".nav-aside .main-level > li.active ul ul > li.active");
        if (activeLiElements.length) activeLiElements.forEach(function(el) {
            el.parentElement.classList.add("show");
            el.parentElement.parentElement.classList.add("open");
        });
    }
    // dropdown for nav aside
    var navDropdown = document.querySelectorAll(".nav-dropdown");
    if (navDropdown) navDropdown.forEach(function(el) {
        el.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            el.nextElementSibling.classList.toggle("show");
            el.classList.toggle("open");
        });
    });
    // in page nav
    $716de60f7510b94a$var$setOverflowInPageNav();
    //observer for in page nav
    var observerOptions = {
        rootMargin: "-30% 0px -70% 0px"
    };
    var observer = new IntersectionObserver(observerCallback, observerOptions);
    function observerCallback(entries, observer) {
        entries.forEach(function(entry) {
            var entryId = entry.target.dataset.linkSubNav.replace("section_", "");
            if (document.querySelector(".menuheader_".concat(entryId))) {
                if (entry.isIntersecting) document.querySelector(".menuheader_".concat(entryId)).classList.add("active");
                else document.querySelector(".menuheader_".concat(entryId)).classList.remove("active");
            }
        });
    }
    var target = ".section-block";
    document.querySelectorAll(target).forEach(function(i) {
        if (i) observer.observe(i);
    });
    window.addEventListener("resize", function() {
        setTimeout(function() {
            $716de60f7510b94a$var$setOverflowInPageNav();
        }, 800);
    });
});
function $716de60f7510b94a$var$setOverflowInPageNav() {
    var inPageNavContainer = document.querySelector(".in-page-sub-nav");
    var inPageNavElement = document.querySelectorAll(".in-page-sub-nav ul li");
    var inPageDropdown = document.querySelector(".in-page-sub-nav-container .dropdown-menu");
    var widthOfInPageNavContainer = 0;
    var widthOfInPageNavElements = 0;
    var elementsNotInView = [];
    if (inPageNavContainer) {
        widthOfInPageNavContainer = inPageNavContainer.clientWidth;
        document.querySelector(".inPageElementLength").value = inPageNavElement.length;
        inPageNavElement.forEach(function(item) {
            var itemPos = window.direct.getPosition(item, inPageNavContainer);
            if (itemPos.x + item.clientWidth > widthOfInPageNavContainer - 70) elementsNotInView.push(item);
            widthOfInPageNavElements += item.clientWidth;
        });
        inPageDropdown.innerHTML = "";
        elementsNotInView.forEach(function(el) {
            var newEl = el.cloneNode(true);
            newEl.classList.remove("nav-item");
            newEl.classList.add("dropdown-item");
            inPageDropdown.appendChild(newEl);
        });
        if (widthOfInPageNavElements > widthOfInPageNavContainer) {
            document.querySelector(".in-page-sub-nav ul.nav").classList.add("show");
            document.querySelector(".overflown-toggle").classList.add("show");
        } else {
            document.querySelector(".in-page-sub-nav ul.nav").classList.remove("show");
            document.querySelector(".overflown-toggle").classList.remove("show");
        }
    }
}



var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");
document.addEventListener("DOMContentLoaded", function() {
    var codeNotFormatted = document.querySelectorAll("pre:not(.formatted)");
    codeNotFormatted.forEach(function(c) {
        var container = document.createElement("div");
        container.wrapAll(c);
        if (container.querySelector("code")) {
            container.classList.add("snippet-container");
            container.insertAdjacentHTML("afterbegin", '<a class="copy-to-clipboard-button-not-formatted btn btn-copy-not-formatted">Copy</a>');
            container.insertAdjacentHTML("beforeend", '<textarea style="display:none;"></textarea>');
            container.querySelector("code").classList.add("code-snippet");
            var textA = container.querySelector("textarea");
            var btn = container.querySelector(".copy-to-clipboard-button-not-formatted");
            textA.value = $1e75e111dfe3eb37$var$unescapeHTML(container.querySelector("code").innerHTML.replace(/<br\s*\\?>/g, "\r\n").replace(/<\/?[^>]+(>|$)/g, ""));
            btn.addEventListener("click", function() {
                window.direct.selectText(container.querySelector(".code-snippet"));
                navigator.clipboard.writeText(textA.value).then(function() {
                    btn.setAttribute("data-copy-state", "copy-success");
                    setTimeout(function() {
                        btn.removeAttribute("data-copy-state");
                    }, 2000);
                });
            });
        }
    });
    var allCodeSnippetContainers = document.querySelectorAll(".all-code-language-container");
    var codeComponents = {};
    allCodeSnippetContainers.forEach(function(container, idx) {
        codeComponents["vm-snippet-".concat(idx)] = new window.Vue({
            name: "code snippet-".concat(container.id),
            el: "#".concat(container.id),
            data: function() {
                return {
                    snippetUrl: "",
                    selectedLanguage: {},
                    canLinkToAPIExplorer: false,
                    loading: false,
                    languageOptions: {
                        "backend": [
                            {
                                name: "Java",
                                value: "JAVA",
                                paramExplorer: "JAVA"
                            },
                            {
                                name: ".NET",
                                value: "DOTNET",
                                paramExplorer: "DOTNET"
                            },
                            {
                                name: "Node.js",
                                value: "JS",
                                paramExplorer: "JS"
                            },
                            {
                                name: "PHP",
                                value: "PHP",
                                paramExplorer: "PHP"
                            },
                            {
                                name: "Python",
                                value: "PYTHON",
                                paramExplorer: "PYTHON"
                            },
                            {
                                name: "Ruby",
                                value: "RUBY",
                                paramExplorer: "RUBY"
                            }
                        ]
                    }
                };
            },
            mounted: function() {
                var storedLanguage = sessionStorage.getItem("language");
                if (storedLanguage) this.selectedLanguage = JSON.parse(storedLanguage);
                else {
                    sessionStorage.setItem("language", JSON.stringify({
                        name: "Java",
                        value: "JAVA",
                        paramExplorer: "JAVA"
                    }));
                    this.selectedLanguage = {
                        name: "Java",
                        value: "JAVA",
                        paramExplorer: "JAVA"
                    };
                }
                if (document.querySelector("#".concat(container.id, " #tryitButton"))) {
                    this.canLinkToAPIExplorer = true;
                    this.getSnippets();
                }
            },
            methods: {
                getSnippets: function() {
                    return (0, $kSuI9._)(function() {
                        var snippetUrl, codeEl, response, jsonData, error;
                        return (0, $l29cN.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    this.loading = true;
                                    snippetUrl = "".concat(document.querySelector("#".concat(container.id, " #snippetUrl")).value, "?language=").concat(this.selectedLanguage.paramExplorer);
                                    codeEl = "#".concat(container.id, " .").concat(this.selectedLanguage.paramExplorer);
                                    this.snippetUrl = snippetUrl;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4,
                                        fetch(snippetUrl)
                                    ];
                                case 2:
                                    response = _state.sent();
                                    if (!response.ok) throw new Error(response.status);
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 3:
                                    jsonData = _state.sent();
                                    document.querySelector(codeEl).innerHTML = jsonData.sampleBody;
                                    Prism.highlightElement(document.querySelector(codeEl));
                                    if (jsonData.apiExplorerParameters) document.querySelector("#".concat(container.id, " #tryitButton")).href = "".concat(document.querySelector("#".concat(container.id, " #tryitUrl")).value).concat(jsonData.apiExplorerParameters);
                                    else document.querySelector("#".concat(container.id, " #tryitButton")).style.display = "none";
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    error = _state.sent();
                                    console.error("There was an error!", error);
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    this.loading = false;
                                    return [
                                        7
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).apply(this);
                },
                setLanguage: function(langItem) {
                    Object.entries(codeComponents).forEach(function(codeInstance) {
                        codeInstance[1].selectedLanguage = langItem;
                        if (codeInstance[1].snippetUrl) codeInstance[1].getSnippets();
                    });
                    sessionStorage.setItem("language", JSON.stringify(langItem));
                    if (document.querySelector(".language-nav")) $1e75e111dfe3eb37$var$setLanguageNav(langItem.value);
                },
                copy: function(activeCodeSnippet) {
                    var _this = this;
                    var code = "code-".concat(activeCodeSnippet.value);
                    var textA = this.$refs[activeCodeSnippet.value];
                    textA.value = $1e75e111dfe3eb37$var$unescapeHTML(this.$refs[code].innerHTML.replace(/<\/?[^>]+(>|$)/g, ""));
                    window.direct.selectText(this.$refs[code]);
                    navigator.clipboard.writeText(this.$refs[activeCodeSnippet.value].value).then(function() {
                        _this.$refs.copy.setAttribute("data-copy-state", "copy-success");
                        setTimeout(function() {
                            textA.value = null;
                            _this.$refs.copy.removeAttribute("data-copy-state");
                            window.getSelection().removeAllRanges();
                        }, 2000);
                    });
                }
            }
        });
        window.direct.setGlobalLanguage = setGlobalLanguage;
        function setGlobalLanguage(language) {
            Object.entries(codeComponents).forEach(function(codeInstance) {
                codeInstance[1].setLanguage(language);
            });
            if (document.querySelector(".language-nav")) $1e75e111dfe3eb37$var$setLanguageNav(language);
        }
        if (document.querySelector(".language-nav")) $1e75e111dfe3eb37$var$setLanguageNav();
    });
});
function $1e75e111dfe3eb37$var$unescapeHTML(v) {
    return v.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
}
function $1e75e111dfe3eb37$var$setLanguageNav() {
    var selectedLanguage = JSON.parse(sessionStorage.getItem("language"));
    if (selectedLanguage) document.querySelectorAll(".language-nav a").forEach(function(item) {
        item.classList.remove("active");
        if (item.classList.contains("language-nav-".concat(selectedLanguage.value))) item.classList.add("active");
    });
}


document.addEventListener("DOMContentLoaded", function() {
    var allTablesOnPage = document.querySelectorAll("table:not(.payment-products, .action-table)");
    if (allTablesOnPage.length > 0) allTablesOnPage.forEach(function(t) {
        t.classList.add("table");
        var trs = document.querySelectorAll("tr");
        var tds = document.querySelectorAll("td");
        trs.forEach(function(row) {
            row.removeAttribute("style");
        });
        tds.forEach(function(cell) {
            cell.removeAttribute("style");
        });
        $20fb99d47cfa9b70$var$wrap(t, document.createElement("div"));
    });
});
function $20fb99d47cfa9b70$var$wrap(el, wrapper) {
    wrapper.classList.add("table-responsive");
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}



var $c6Xmf = parcelRequire("c6Xmf");
document.addEventListener("DOMContentLoaded", function() {
    var popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    var popoverList = (0, $c6Xmf._)(popoverTriggerList).map(function(popoverTriggerEl) {
        return new window.bootstrap.Popover(popoverTriggerEl);
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var video = document.querySelector("#homepage-video");
    if (video) {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            var source = document.querySelector("#homepage-video");
            source.setAttribute("src", "/global/images/homepage_video-hevc-safari.mp4");
            source.setAttribute("type", "video/mp4");
            source.setAttribute("codecs", "hevc");
        }
        video.addEventListener("ended", function(event) {
            video.currentTime = 4.000;
            video.play();
        });
    }
});


document.addEventListener("DOMContentLoaded", function() {
    var thumbsUpBtn = document.querySelector("button.up");
    var thumbsDownBtn = document.querySelector("button.down");
    var thumbsSendBtn = document.querySelector("button.send");
    var messageContainer = document.querySelector(".thumbs-message-container");
    var buttonContainer = document.querySelector(".thumbs-button-container");
    var thumbValue = document.querySelector(".thumb-input");
    var pageValue = document.querySelector(".page-input");
    var messageValue = document.querySelector(".message-input");
    if (thumbsUpBtn) {
        thumbsUpBtn.addEventListener("click", function() {
            thumbValue.value = "up";
            pageValue.value = window.location.pathname;
            messageContainer.classList.toggle("show");
            buttonContainer.classList.toggle("show");
            gtag("event", "_sendThumb", {
                "event_label": "thumbs",
                "value": "up"
            });
        });
        thumbsDownBtn.addEventListener("click", function() {
            thumbValue.value = "down";
            pageValue.value = window.location.pathname;
            messageContainer.classList.toggle("show");
            buttonContainer.classList.toggle("show");
            gtag("event", "_sendThumb", {
                "event_label": "thumbs",
                "value": "down"
            });
        });
        thumbsSendBtn.addEventListener("click", function() {
            $b831cb87f68dc885$var$sendThumb();
        });
    }
});
function $b831cb87f68dc885$var$sendThumb() {
    var messageContainer = document.querySelector(".thumbs-message-container");
    var responseContainer = document.querySelector(".thumbs-response-container");
    var form = document.querySelector("#thumbsForm");
    grecaptcha.ready(function() {
        grecaptcha.execute("6Lfa2P8UAAAAABC6DlDHvyzoW7xhzeCgb5zoPaY4", {
            action: "submit"
        }).then(function(token) {
            form.insertAdjacentHTML("afterbegin", '<input type="hidden" name="g-recaptcha-response" value="'.concat(token, '" />'));
            var formData = new FormData(form);
            var object = {};
            formData.forEach(function(value, key) {
                return object[key] = value;
            });
            var headers = new Headers({
                "Content-Type": "application/json"
            });
            var options = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(object)
            };
            fetch(form.action, options).then(function(res) {
                return res.json();
            }).then(function(res) {
                if (res.success) {
                    responseContainer.classList.toggle("show");
                    messageContainer.classList.toggle("show");
                } else console.error(res.reason);
            });
            return false;
        });
    });
}


document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("path,rect,polygon,circle,line,text").forEach(function(e) {
        // replace the fill colors
        var fillColor = e.getAttribute("fill");
        var strokeColor = e.getAttribute("stroke");
        switch(true){
            case fillColor === "#4E4745" || strokeColor === "#4E4745":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-dark-gray)");
                break;
            case fillColor === "white" || strokeColor === "white":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-white)");
                break;
            case fillColor === "#006A7A" || strokeColor === "#006A7A":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-dark-green)");
                break;
            case fillColor === "#007B7C" || strokeColor === "#007B7C":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-dark-green)");
                break;
            case fillColor === "#E5F2F4" || strokeColor === "#E5F2F4":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-light-green-gray)");
                break;
            case fillColor === "#FDE6F1" || strokeColor === "#FDE6F1":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-light-red-gray)");
                break;
            case fillColor === "#D6006B" || strokeColor === "#D6006B":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-red)");
                break;
            case fillColor === "#008094" || strokeColor === "#008094":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-green)");
                break;
            case fillColor === "#E60073" || strokeColor === "#E60073":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-light-red)");
                break;
            case fillColor === "#9A9695" || strokeColor === "#9A9695":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-gray)");
                break;
            default:
                e.setAttribute(fillColor ? "fill" : "stroke", fillColor ? fillColor : strokeColor);
        }
    });
});



var $c6Xmf = parcelRequire("c6Xmf");
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".show-more a").forEach(function(showMore) {
        showMore.addEventListener("click", function(e) {
            var parent = showMore.dataset.parent;
            showMoreItems(parent, e.target);
        });
    });
    function showMoreItems(parent, showMoreLink) {
        var hiddenItems = document.querySelectorAll("#".concat(parent, " .hidden-item"));
        var hiddenItemsArray = (0, $c6Xmf._)(hiddenItems);
        hiddenItemsArray.forEach(function(hiddenItem) {
            hiddenItem.style.display = "list-item";
        });
        showMoreLink.parentNode.style.display = "none";
    }
});


document.addEventListener("DOMContentLoaded", function() {
    window.AOS.init();
});


document.addEventListener("DOMContentLoaded", function() {
    var checkboxes = document.querySelectorAll(".custom-checkbox");
    if (checkboxes.length === 0) return;
    var checkedInputs = [];
    var storedCheckedInputs = JSON.parse(sessionStorage.getItem("checkedInputs"));
    if (storedCheckedInputs) {
        checkedInputs = storedCheckedInputs;
        checkedInputs.forEach(function(checkId) {
            var allNumbered = document.querySelectorAll(".check_".concat(checkId));
            allNumbered.forEach(function(numbered) {
                numbered.classList.add("checked");
            });
        });
        checkboxes.forEach(function(checkbox) {
            var checkId = checkbox.querySelector("input").getAttribute("data-checkbox");
            if (checkedInputs.includes(checkId)) checkbox.querySelector("input").checked = true;
        });
    }
    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener("click", function() {
            var checkId = checkbox.querySelector("input").getAttribute("data-checkbox");
            var allNumbered = document.querySelectorAll(".check_".concat(checkId));
            allNumbered.forEach(function(numbered) {
                if (checkbox.querySelector("input").checked) {
                    numbered.classList.add("checked");
                    checkedInputs.push(checkId);
                } else {
                    numbered.classList.remove("checked");
                    checkedInputs = checkedInputs.filter(function(item) {
                        return item !== checkId;
                    });
                }
            });
            sessionStorage.setItem("checkedInputs", JSON.stringify(checkedInputs));
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    // Inline form only
    var signupToggle = document.querySelector("#signup-toggle");
    var signupCancel = document.querySelector(".btn-hide-form");
    var signupForm = document.querySelector("#signup-form");
    var createAccountBtn = document.querySelector('.step a[href="#step-1"]');
    if (createAccountBtn) {
        createAccountBtn.removeAttribute("href");
        createAccountBtn.addEventListener("click", function(e) {
            e.preventDefault();
            document.querySelector("#step-1").scrollIntoView();
            toggleSignupForm(true);
        });
    }
    var toggleSignupForm = function(show) {
        signupToggle.style.display = show ? "none" : "inline-block";
        signupForm.classList.toggle("hide-signup", !show);
        signupForm.classList.toggle("show-signup", show);
    };
    signupCancel.addEventListener("click", function(e) {
        e.preventDefault();
        toggleSignupForm(false);
    });
    if (signupToggle) signupToggle.addEventListener("click", function(e) {
        e.preventDefault();
        toggleSignupForm(true);
    });
    // Submit for both forms
    var signupBtns = document.querySelectorAll(".signup-btn");
    signupBtns.forEach(function(btn) {
        btn.addEventListener("click", function(event) {
            event.preventDefault();
            var formId = btn.dataset.formId;
            var form = document.querySelector("#".concat(formId));
            var errorForm = document.querySelector("#".concat(formId, " .error-form"));
            var successForm = document.querySelector("#".concat(formId, " + .success-form"));
            var signupOverlay = document.querySelector("#".concat(formId, " .signup-overlay"));
            var signupBtn = document.querySelector("#".concat(formId, " #signup-btn"));
            var replaceMail = document.querySelector("#".concat(formId, " + .success-form #replace-mail"));
            var formElements = form.querySelectorAll(".form-control");
            signupOverlay.style.display = "block";
            if (!form.checkValidity()) {
                event.stopPropagation();
                signupBtn.style.display = "block";
                setTimeout(function() {
                    signupOverlay.style.display = "none";
                }, 500);
            } else {
                var data = new FormData(form);
                var signupData = {
                    accountInfo: {
                        isp: data.get("isp"),
                        firstName: data.get("firstName"),
                        lastName: data.get("lastName"),
                        companyName: data.get("companyName"),
                        emailAddress: data.get("emailAddress")
                    },
                    captcha: {
                        captchaInput: data.get("captchaInput"),
                        captchaText: data.get("captchaText"),
                        key: data.get("key")
                    }
                };
                fetch("/app/service/signup/create-account", {
                    method: "POST",
                    body: JSON.stringify(signupData)
                }).then(function(response) {
                    return response.json();
                }).then(function(res) {
                    if (res.status) {
                        $b8301608c7214b53$var$getCaptchaImage();
                        errorForm.innerHTML = res.detail;
                        errorForm.style.display = "block";
                        formElements.forEach(function(element) {
                            element.addEventListener("input", function() {
                                element.classList.remove("is-invalid");
                                errorForm.style.display = "none";
                            });
                        });
                    } else {
                        form.reset();
                        form.style.display = "none";
                        successForm.style.display = "block";
                        replaceMail.innerHTML = replaceMail.innerHTML.replace(/aaaaa/g, res.emailAddress);
                    }
                    setTimeout(function() {
                        signupOverlay.style.display = "none";
                    }, 500);
                });
            }
            form.classList.add("was-validated");
        });
    });
    document.querySelectorAll(".refresh-captcha").forEach(function(captchaBtn) {
        captchaBtn.addEventListener("click", function(e) {
            e.preventDefault();
            $b8301608c7214b53$var$getCaptchaImage();
        });
    });
    $b8301608c7214b53$var$getCaptchaImage();
});
function $b8301608c7214b53$var$getCaptchaImage() {
    var captchaImages = document.querySelectorAll(".signup-captcha");
    var captchaTexts = document.querySelectorAll(".captchaText");
    var keys = document.querySelectorAll(".key");
    fetch("/app/service/signup/captcha").then(function(response) {
        return response.json();
    }).then(function(data) {
        captchaImages.forEach(function(captchaImage) {
            captchaImage.setAttribute("src", data.imageData);
        });
        captchaTexts.forEach(function(captchaText) {
            captchaText.value = data.captchaText;
        });
        keys.forEach(function(key) {
            key.value = data.key;
        });
    });
}


window.direct = {};

})();
//# sourceMappingURL=default.js.map
